import Icon from '../components/Icon.vue'

Icon.register({
  'tint-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M633.8 458.1L495 350.8C495.5 345.2 496 339.6 496 333.9 496 222.2 396.2 180.6 349.2 22.1 341.3-6.7 299.8-8 290.8 22.1 275.3 74.4 253.9 114 232.3 147.8L45.5 3.4C38.5-2.1 28.4-0.8 23 6.2L3.4 31.4C-2 38.4-0.8 48.5 6.2 53.9L594.5 508.6C601.5 514.1 611.6 512.8 617 505.8L636.6 480.6C642 473.6 640.8 463.5 633.8 458.1zM144 333.9C144 432.4 222.7 512 320 512 364.7 512 405.4 495 436.4 467.3L162.7 255.8C151.3 279.3 144 304.1 144 333.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tint-slash.js
// module id = QtmB
// module chunks = 144